import React from 'react';
import { motion } from 'framer-motion';
import img1 from "../../assets/about/img1.jpg";

const About = () => {
    return (
        <div className="bg-linen min-h-screen pt-28 md:pt-32 pb-16 md:pb-24 font-sans text-charcoal">
            <div className="max-w-4xl mx-auto px-6 text-center">
                <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="text-brass uppercase tracking-widest text-sm font-semibold mb-4 block"
                >
                    Our Story
                </motion.span>
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif mb-8 md:mb-10 leading-tight"
                >
                    Five Generations of <br /> Uncompromising Craft
                </motion.h1>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                    className="space-y-8 text-lg text-charcoal/70 leading-relaxed font-light mx-auto"
                >
                    <p>
                        Weaving Hand is one of the leading furniture manufacturers in Chennai with a legacy of 5 generations. We manufacture premium wooden furniture, antique furniture, and cane weaving furniture for homes, architects, and interior designers across Chennai and India.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 }}
                    className="mt-24 px-4"
                >
                    <a
                        href="https://medium.com/@weavinghandindia/weaving-hand-5-generations-of-excellence-in-furniture-manufacturing-antique-furniture-and-cane-3aeb3c71d3f8"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group block relative max-w-3xl mx-auto p-8 md:p-14 bg-white/40 backdrop-blur-md border border-brass/10 rounded-3xl hover:bg-white/80 hover:shadow-[0_20px_50px_rgba(184,134,11,0.15)] hover:border-brass/30 transition-all duration-700 text-center overflow-hidden"
                    >
                        {/* Decorative background element */}
                        <div className="absolute top-0 right-0 w-32 h-32 bg-brass/5 rounded-full -mr-16 -mt-16 blur-3xl group-hover:bg-brass/10 transition-colors duration-700"></div>
                        
                        <span className="inline-block bg-brass/10 text-brass px-5 py-2 text-[10px] font-bold uppercase tracking-[0.25em] rounded-full mb-8 group-hover:bg-brass group-hover:text-linen transition-all duration-500">
                            Our Story on Medium
                        </span>
                        
                        <h2 className="text-2xl md:text-4xl font-serif text-charcoal group-hover:text-brass transition-colors duration-500 leading-tight mb-6">
                            Furniture Manufacturers in Chennai | <br className="hidden md:block"/> 
                            <span className="italic font-light opacity-80">Antique Furniture & Cane Weaving Experts</span>
                        </h2>
                        
                        <div className="w-16 h-[1px] bg-brass/20 mx-auto mb-8 group-hover:w-32 group-hover:bg-brass/40 transition-all duration-700"></div>
                        
                        <p className="text-charcoal/60 text-sm md:text-lg font-light mb-10 max-w-xl mx-auto leading-relaxed italic">
                            "Discover our journey of five generations, preserving the art of antique craftsmanship and traditional cane weaving."
                        </p>
                        
                        <div className="flex items-center justify-center text-brass font-bold tracking-[0.2em] uppercase text-[10px] md:text-xs">
                            <span className="relative">
                                Read the full story
                                <span className="absolute bottom-0 left-0 w-full h-[1px] bg-brass/30 group-hover:h-[2px] group-hover:bg-brass transition-all duration-300"></span>
                            </span>
                            <span className="ml-3 transform group-hover:translate-x-3 transition-transform duration-500 text-lg">→</span>
                        </div>
                    </a>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.8 }}
                    className="mt-16"
                >
                    <a className="inline-block px-10 py-4 border border-charcoal text-charcoal hover:bg-charcoal hover:text-linen transition-all duration-300 tracking-widest uppercase text-xs"
                        href="tel:+91 9444161667">
                        Speak With An Artisan
                    </a>
                </motion.div>
            </div>

            <div className="max-w-7xl mx-auto mt-32 px-6">
                {/* Decorative spacer/banner */}
                <div className="w-full h-[400px] lg:h-[600px] bg-charcoal rounded-xl relative overflow-hidden flex items-center justify-center">
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-40 mix-blend-luminosity"
                        style={{ backgroundImage: `url(${img1})` }}
                    ></div>
                    <h2 className="relative z-10 text-linen text-4xl lg:text-6xl font-serif italic font-light drop-shadow-xl text-center px-6">
                        "Built today, <br /> cherished forever."
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default About;